import { faMagnifyingGlassChart } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlassChart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

export const MagnifyingGlassChart: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faMagnifyingGlassChart} {...props} />;
};
